<template>
  <div class="aside">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt="">
      <div class="name">
        <span>友友圈</span>
        <span>圈现场后台管理</span>
      </div>
    </div>
    <ul class="slider">
      <li id="Index" class="active">
        <router-link to="/Index">首页</router-link>
      </li>
      <li id="Order">
        <router-link to="/Order">订单</router-link>
      </li>
      <li id="Personnel">
        <router-link to="/Personnel">人员</router-link>
      </li>
      <li id="Account">
        <router-link to="/Account">账户流水</router-link>
      </li>
      <li id="Subpro">
        <router-link to="/Subpro">下级代理</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default{
    data(){
      return{
  
        }
    },
    created(){
      if("getCookie('userType')"==4){
          $("#Personnel").css('display','none');
          $("#Account").css('display','none');
          $("#Subpro").css('display','none');
        };
      $(document).ready(function(){
        $(".aside>.slider>li").click(function(){
          $(".aside>.slider>li").removeClass("active");
          $(this).addClass("active");
        })
      });
     // if(getCookie('userType')==2||getCookie('userType')==3){
     //    $("#Subpro").css('display','none');
     //    var Subpro=$('#Subpro').text();
     //    console.log(Subpro)
     //    }
        
    },
    methods:{
  
    }
  }
</script>
<style scoped lang="scss">
  .aside ul>.active{
    background: #F43941;
  }
  .aside ul>.active>a{
    color: #fff;
  }
  .aside {
    width:2.87rem;
    height:10.8rem;
    background:rgba(255,255,255,1);
    box-shadow:0 0.04rem 0.13rem 0 rgba(60,60,60,0.23);
  }
  .logo{
    width: 2.87rem;
    height: 1.49rem;
  }
  img{
    width: 1.37rem;
    height: 0.65rem;
    margin: 0.15rem 0.78rem 0.12rem 0.72rem; 
  } 
  .name{
    height:0.31rem;
    font-size:0.14rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(244, 57, 65, 1);
    line-height: 0.35rem;
    padding-bottom: 0.26rem;
  }
  .name>span{
    text-align: center;
    display: block;
  }
  .aside ul{
    width: 2.87rem;
    margin-top: 0.3rem;
  }
  .aside ul>li{
    width:2.87rem;
    height:0.64rem;
    line-height:0.64rem;
    background:rgba(255,235,235,1);
    border-bottom: 0.01rem solid #fff;
    cursor: pointer;
  }
 /* .aside ul>li:hover{
    background:rgba(244, 57, 65, 1);
  }
  .aside ul>li:hover>a{
    color: rgba(255, 255, 255, 1);
  }*/
  .aside ul>li>a{
    display: inline-block;
    width:2.87rem;
    height:0.64rem;
    line-height:0.64rem;
    display: block;
    font-size:0.2rem;
    font-family:STHeitiSC-Light;
    font-weight:500;
    color:rgba(254,57,65,1);
    text-align: center;
    letter-spacing: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/slider.vue